import React from "react";
import { StyleSheet } from 'react-native';
import Text from "theme/Text";


const Description = ( { children, style = {} } = {} ) => {
	return (
		<Text
			category={"c2"}
			style={[ styles.text, style ]}>
			
			{ children }
		</Text>
	)
}

const styles = StyleSheet.create({
	text: { marginBottom: 10 },
});

export default Description;
